import { Link } from "react-router-dom";
import { getPageAllowedRoles } from "../../config/roles";
import { usePageState } from "../../context/usePageState";

/** Where import sources come from, and who can add one. */
export function DataImportManageSources() {
  const { hasAnyRole } = usePageState();
  const canManageWarehouseApplications = hasAnyRole(
    getPageAllowedRoles("warehouse-applications")
  );

  return (
    <p>
      Data sources are managed through Warehouse Applications.{" "}
      {canManageWarehouseApplications ? (
        <>
          To add a new import source, open{" "}
          <Link to="/warehouse-applications" target="_blank">
            Warehouse Applications
          </Link>{" "}
          in Settings.
        </>
      ) : (
        "Contact an administrator if you need a new import source added."
      )}
    </p>
  );
}

export default DataImportManageSources;
